import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import {
  documentacionPorSolicitud,
  obtenerDocumentacion,
} from "../../Services/Rest";
import EliminarAnexo from "./EliminaAnexos";
import CreaDocumentacion from "../Modals/crear/CreaDocumentacion";
import { descargarDocumento } from "../Seguridad/DescargarDocumento";

const InfoDocumentacionSolicitudes = (props) => {
  const [list, setList] = useState([]); // Lista de documentos
  const [instituciones, setInstituciones] = useState([]); // Lista de instituciones
  const [filtroInstitucion, setFiltroInstitucion] = useState(""); // ID de la institución seleccionada
  const [currentPage, setCurrentPage] = useState(1); // Página actual
  const itemsPerPage = 10; // Elementos por página

  const cookie = new Cookies();
  const urlA = obtenerDocumentacion;
  const urlU = documentacionPorSolicitud;

  let urlendpoint;
  if (cookie.get("tipo_Usuario") === "1") {
    urlendpoint = urlA;
  } else if (["2", "3"].includes(cookie.get("tipo_Usuario"))) {
    urlendpoint = `${urlU}${cookie.get("institucionid")}`;
  }

  useEffect(() => {
    axios
      .get("https://suadesarrollo.azurewebsites.net/api/ObtenerInstituciones", {
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
      })
      .then((response) => {
        setInstituciones(response.data);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    axios
      .get(urlendpoint, {
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
      })
      .then((response) => setList(response.data))
      .catch((error) => console.log(error));
  }, [urlendpoint]);

  const buscarPorInstitucion = () => {
    const endpointBusqueda = `${documentacionPorSolicitud}${filtroInstitucion}`;
    axios
      .get(endpointBusqueda, {
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
      })
      .then((response) => {
        setList(response.data);
      })
      .catch((error) => console.log(error));
  };

  const actualizarEstado = (id, nuevoEstado) => {
    const url = `https://suadesarrollo.azurewebsites.net/api/ActualizaEstadosAnexos?IdAnexo=${id}`;
    axios
      .post(
        url,
        { estado: nuevoEstado },
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      )
      .then(() => {
        setList((prevList) =>
          prevList.map((item) =>
            item.id === id ? { ...item, estado: nuevoEstado } : item,
          ),
        );
      })
      .catch((error) => console.log(error));
  };

  // Calcular datos de la página actual
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = list.slice(indexOfFirstItem, indexOfLastItem);

  // Navegación de página
  const totalPages = Math.ceil(list.length / itemsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  return (
    <Fragment>
      <div className="container">
        <h3>Documentación de Solicitudes</h3>
        <form className="mb-4">
          {cookie.get("tipo_Usuario") == 1 ? (
            <select
              className="form-control mb-2"
              onChange={(e) => setFiltroInstitucion(e.target.value)}
            >
              <option value="">Seleccione una institución</option>
              {instituciones.map((institucion) => (
                <option key={institucion.id} value={institucion.id}>
                  {institucion.razon_Social}
                </option>
              ))}
            </select>
          ) : (
            <h></h>
          )}
          {cookie.get("tipo_Usuario") == 1 ? (
            <button
              type="button"
              className="btn btn-primary"
              onClick={buscarPorInstitucion}
            >
              Buscar
            </button>
          ) : (
            <g></g>
          )}
        </form>
        <CreaDocumentacion />
        <hr />
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nombre</th>
              <th>Estado</th>
              <th>Sede</th>
              <th>fechaCorte</th>
              <th>Acciones</th>
              <th>Aprobación</th>
              <th>Eliminar</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.nombre}</td>
                <td>{item.estado == 0 ? "Sin aprobación" : "Aprobado"}</td>
                <td>{item.sede}</td>
                <td>{item.fechaCorte}</td>
                <td>
                  {item.archivo ? (
                    <button
                      className="btn btn-success"
                      onClick={() => descargarDocumento(item.archivo)}
                    >
                      Descargar Adjunto
                    </button>
                  ) : (
                    "Sin archivo"
                  )}
                </td>
                {cookie.get("tipo_Usuario") == 1 && (
                  <td>
                    {item.estado == 0 ? (
                      <button
                        className="btn btn-primary"
                        onClick={() => actualizarEstado(item.id, 1)}
                      >
                        Aprobar
                      </button>
                    ) : (
                      <button
                        className="btn btn-danger"
                        onClick={() => actualizarEstado(item.id, 0)}
                      >
                        Quitar Aprobación
                      </button>
                    )}
                  </td>
                )}
                <td>
                  {item.estado === 0 && cookie.get("tipo_Usuario") != 3 ? (
                    <EliminarAnexo id={item.id} />
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Paginador */}
        <nav className="d-flex justify-content-between">
          <button
            className="btn btn-secondary"
            onClick={handlePreviousPage}
            disabled={currentPage == 1}
          >
            Anterior
          </button>
          <span>
            Página {currentPage} de {totalPages}
          </span>
          <button
            className="btn btn-secondary"
            onClick={handleNextPage}
            disabled={currentPage == totalPages}
          >
            Siguiente
          </button>
        </nav>
      </div>
    </Fragment>
  );
};

export default InfoDocumentacionSolicitudes;
